import styles from "../components/AuthPageContainer.module.css"

export const ForgotPasswordLink = () => (
  <p className={styles.accountLink}>
    Forgot your password?{" "}
    <a className="signin-footer-link" href="/reset-password">
      Reset password
    </a>
  </p>
)
